// extracted by mini-css-extract-plugin
module.exports = {"hidden":"Webcam_hidden__Xv_0W","textEmphasis":"Webcam_textEmphasis__6wKSc","webcamContainer":"Webcam_webcamContainer__phtv_","webcam":"Webcam_webcam___aUyC"};